
import Vue from "vue";
import $ from 'jquery';
const App = Vue.extend({
  name: "App",
  data(){
    return{
      includeLink:""
    }
  },  
  watch:{
    $route(to,from){
      if(to.name=="Login"){
        this.includeLink=""
      }else{
        this.includeLink="MainManage,BIMView"
      }
    }
  },
  mounted() {
    var themeName = localStorage.getItem("themeName");
    if (themeName == null || themeName == "null") {
      themeName = "theme1";
    }
    console.log(this.$vnode.componentOptions);
    $("#app").addClass(themeName);
  }
});
export default App;
